export const priceSeparator = (value: string | number) => {
  if (!value) {
    return '';
  }
  value = value.toString();
  value = value.split(',').join('');
  value = value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$&,');
  return value;
};
export const priceOriginal = function (value: string) {
  value = value.toString();
  value = value.split(',').join('');
  return value;
};
